exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-rate__icon {\n  font-size: 0.63rem !important;\n}\n.van-rate__item {\n  margin-right: 0.4rem;\n}\n.box .content .van-icon {\n  line-height: initial;\n}\n.van-field__control {\n  font-size: 16px;\n}\n", ""]);

// exports
